export const buildReferralMessage = (url: string): string =>
	`Si tienes un plan de pensiones antiguo muerto de risa (típico de un trabajo anterior), te recomiendo Arca Digital. Yo lo uso y va genial. Traspasarlo es gratis y se gestiona todo desde su app. Te dejo mi enlace: ${url}`;
